import { render, staticRenderFns } from "./UpdateCheckModal.vue?vue&type=template&id=71f1eb7b&scoped=true&"
import script from "./UpdateCheckModal.vue?vue&type=script&lang=js&"
export * from "./UpdateCheckModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1eb7b",
  null
  
)

export default component.exports